import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ParentUserResponseDTO,
  RequestImpersonatedUserDTO,
  RequestUsersByFilterDTO,
  ResponseImpersonatedUserDTO,
  UserDependenciesRequestDTO,
  UserDTO,
} from '@app/users/model/users-model';
import { MatRadioChange } from '@angular/material/radio';
import { AdminStore } from '@app/users/admin-service/admin-service.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';

@Component({
  selector: 'app-search-users',
  templateUrl: './search-users.component.html',
  styleUrls: ['./search-users.component.scss'],
})
export class SearchUsersComponent implements OnInit {
  selectNameForm: FormGroup;
  acceptButtonDisabled: boolean = true;
  usersList: CommonDataDTO[] | ResponseImpersonatedUserDTO[]; //se mantiene invariable
  userSelected: CommonDataDTO;
  showError: boolean = false;
  searchButtonDisabled: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<SearchUsersComponent>,
    private adminStore: AdminStore,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.selectNameForm = this.formBuilder.group({
      user: [''],
    });

    this.selectNameForm.statusChanges.subscribe(() => {
      let usuario = this.selectNameForm.controls.user.value;
      if (usuario) {
        this.searchButtonDisabled = false;
      } else {
        this.searchButtonDisabled = true;
      }
    });

    this.onClickSearch();
  }

  radioChange($event: MatRadioChange) {
    if (this.userSelected) {
      this.acceptButtonDisabled = false;
    } else {
      this.acceptButtonDisabled = true;
    }
  }

  onClickSearch() {
    this.userSelected = undefined;
    this.acceptButtonDisabled = true;
    const name = this.selectNameForm.controls.user.value.toUpperCase();

    if (this.data.impersonatedUser) {
      let requestImpersonatedUser: RequestImpersonatedUserDTO = {
        userId: this.data.typerCreate === 'V' ? this.data.vendor : this.data.infoUser.userId,
        userType: this.data.typerCreate === 'V' ? this.data.typerCreate : this.data.infoUser.userType,
        filter: '',
      };

      this.adminStore.searchImpersonatedUsers(requestImpersonatedUser).then(
        (data: ResponseImpersonatedUserDTO[]) => {
          console.log(data);
          this.usersList = data;
          this.showError = false;
        },
        (err) => {
          this.showError = true;
          this.usersList = [];
        }
      );
    } else {
      let requestUsersByFilter: RequestUsersByFilterDTO = {
        typeOut: this.data.typerCreate === 'V' ? 'E' : this.data.typerCreate,
        division: this.data.division,
        filter: this.selectNameForm.controls.user.value,
        typerCreate: this.data.typerCreate,
        idExtenalCommercial: this.data.idExtenalCommercial,
        action: this.data.action,
      };

      this.adminStore.searchUsers(requestUsersByFilter).then(
        (data: CommonDataDTO[]) => {
          this.usersList = data;
          this.showError = false;
        },
        (err) => {
          this.showError = true;
          this.usersList = [];
        }
      );
    }
  }

  selectName(element: any) {
    element.impersonatedUser = this.data.impersonatedUser;
    this.dialogRef.close(element);
  }

  exit(): void {
    this.dialogRef.close();
  }
}
